<template>
  <v-form
    v-if="editable && editing"
    v-model="valid"
    class="user-details-name"
  >
    <v-text-field
      v-model.trim="firstName"
      label="First Name"
      class="edit-user-name__field"
      :rules="[val => !!(val.trim()) || 'Required']"
    />
    <v-text-field
      v-model.trim="lastName"
      label="Last Name"
      class="edit-user-name__field"
      :rules="[val => !!(val.trim()) || 'Required']"
    />
    <v-btn
      color="secondary"
      class="square-btn"
      :disabled="updating"
      @click="cancelEditUserName"
    >
      <v-icon size="16">
        $faTimes
      </v-icon>
    </v-btn>
    <v-btn
      color="primary"
      :disabled="updating || !valid || !nameHasBeenEdited"
      :loading="updating"
      class="square-btn"
      @click="updateUserName"
    >
      <v-icon size="16">
        $faCheck
      </v-icon>
    </v-btn>
  </v-form>
  <div
    v-else
    class="user-details-name"
  >
    <v-skeleton-loader
      v-if="!resolved"
      type="text"
      width="200px"
    />
    <template v-else>
      <h1>
        {{ displayFullName }}
      </h1>
      <div
        v-if="editable"
        class="edit-user ml-2"
        @click="onEditUserName"
      >
        <v-icon size="16">
          $faPencilAlt
        </v-icon>
        <span class="edit-user-name">Edit Name</span>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserName',
    props: {
      userId: {
        type: Number,
        default: 0,
      },
      savedName: {
        type: Object,
        default () {
          return { firstName: '', lastName: '' }
        },
      },
      editable: Boolean,
      resolved: Boolean,
    },
    data () {
      return {
        firstName: '',
        lastName: '',
        editing: false,
        updating: false,
        updated: false,
        valid: true,
      }
    },
    computed: {
      ...mapGetters({ currentUser: 'Users/currentUser' }),
      displayFullName () {
        const { firstName, lastName } = this.savedName
        const name = []
        if (firstName) name.push(firstName)
        if (lastName) name.push(lastName)
        if (!name.length) return '(No name)'
        return name.join(' ')
      },
      firstNameHasChanged () {
        return this.firstName !== this.savedName.firstName
      },
      lastNameHasChanged () {
        return this.lastName !== this.savedName.lastName
      },
      nameHasBeenEdited () {
        return this.firstNameHasChanged || this.lastNameHasChanged
      },
      updateNamePayload () {
        return {
          ...(this.firstNameHasChanged ? { firstName: this.firstName } : {}),
          ...(this.lastNameHasChanged ? { lastName: this.lastName } : {}),
        }
      },
    },
    watch: {
      savedName () {
        this.initializeUserName()
      },
    },
    methods: {
      initializeUserName () {
        this.firstName = this.savedName.firstName
        this.lastName = this.savedName.lastName
      },
      onEditUserName () {
        this.editing = true
      },
      cancelEditUserName () {
        this.initializeUserName()
        this.editing = false
      },
      updateUserName () {
        this.updating = true
        return this.$store.dispatch('Users/updateUser', { body: this.updateNamePayload, userId: this.userId })
          .then((res) => {
            this.editing = false
            this.initializeUserName()
            if (this.userId === this.currentUser.id) this.$store.commit('Users/setCurrentUserData', res.data.data)
            this.$store.commit('Users/setUserData', res.data.data)
            this.$store.dispatch('updateMessages', { type: 'success', text: 'User name updated' }, { root: true })
          })
          .catch(() => {
            this.$store.dispatch('updateMessages', { type: 'error', text: "We were unable to update this account's settings. Please try again" }, { root: true })
          })
          .finally(() => { this.updating = false })
      },
    },
  }
</script>

<style lang="scss" scoped>

.user-details-name {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }
  .edit-user-name__field {
    max-width: 144px;
    margin-right: 12px;
  }
  .edit-user {
    cursor: pointer;
    opacity: 0.4;
    font-size: 14px;
    letter-spacing: 1px;
    & > .v-icon {
      margin: 0 5px;
    }
    .edit-user-name {
      visibility: hidden;
      text-transform: uppercase;
      vertical-align: middle;
    }
    &:hover {
      opacity: 1;
      & * {
        color: #456E6C;
      }
      .edit-user-name {
        visibility: visible;
      }
    }
  }
</style>
